import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { MENU_RECIPE_LIST_SKIP_TARGET_ID } from 'routes/Menu/accessibility'

import { MENU_FIXED_BANNER_HEIGHT_VAR } from './MenuExperienceFixedBanner'
import { renderContentBlocks } from './renderContentBlocks'

const MENU_CATEGORY_NAV_HEIGHT = '48px'

const SKIP_TARGET_STYLE = {
  scrollMarginTop: `calc(var(--delivery-settings-dropdown-height, 0px) + var(${MENU_FIXED_BANNER_HEIGHT_VAR}, 0px) + ${MENU_CATEGORY_NAV_HEIGHT})`,
}

type CollectionScreenWrapperProps = {
  contentBlocks: MenuContentBlock[]
  collectionId?: string
}

export const CollectionScreenWrapper = ({
  contentBlocks,
  collectionId,
}: CollectionScreenWrapperProps) => {
  const firstRecipeGridIndex = contentBlocks.findIndex(({ type }) => type === 'recipe-grid')

  if (firstRecipeGridIndex === -1) {
    return (
      <div data-testid="menu-experience-collection-screen">
        {renderContentBlocks(contentBlocks, { collectionId })}
      </div>
    )
  }

  return (
    <div data-testid="menu-experience-collection-screen">
      {renderContentBlocks(contentBlocks.slice(0, firstRecipeGridIndex), { collectionId })}
      <div id={MENU_RECIPE_LIST_SKIP_TARGET_ID} tabIndex={-1} style={SKIP_TARGET_STYLE}>
        {renderContentBlocks(contentBlocks.slice(firstRecipeGridIndex), { collectionId })}
      </div>
    </div>
  )
}
